const UnknownRetry = 'Unknown Error Occurred. Please, try again'
const SomethingWentWrong = 'Something went wrong. Failed to Authenticate'
const InvalidRequest = 'Invalid Request'
const PasswordUpdated = 'Password Updated Successfully'
const LoginFailed = 'Login Failed'

export default {
  UnknownRetry,
  SomethingWentWrong,
  InvalidRequest,
  PasswordUpdated,
  LoginFailed,
}
